import { useAuthState } from 'shared/stores';
import { NoPropsJustChildren } from 'shared/types';
import SplunkRum from '@splunk/otel-web';

export function AuthorizedLayout({ children }: NoPropsJustChildren) {
  const authState = useAuthState();
  const user = authState.user.get();

  console.log('Checking for SplunkRum and user existence...');
  if (SplunkRum && user?.id) {
    console.log(`SplunkRum and user existence verified. Setting global attributes for userID ${user.id}`);
    SplunkRum.setGlobalAttributes({
      userID: user?.id,
    });
    console.log('Global attribute for userID set.');
    const attrs = SplunkRum.getGlobalAttributes();
    console.log('attrs', attrs);
  }

  return <>{children}</>;
}
